import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'inf-app-header',
    imports: [CommonModule, MatMenuModule, MatToolbarModule, MatIconModule, MatButtonModule],
    template: `
    <mat-toolbar color="primary">
      <button id="menuToggle" (click)="menuToggleClick.emit()" *ngIf="showMenuToggle()" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
      <img class="h-50 ms-2" alt="infrest logo"  src="../../assets/images/logos/infrest-cockpit.svg" />
      <span class="flex-grow-1"></span>
      <button mat-icon-button [matMenuTriggerFor]="userMenu">
        <mat-icon >account_circle_outline</mat-icon>
      </button>

      <mat-menu #userMenu>
        <button mat-menu-item (click)="logout.emit()">
          <mat-icon>logout</mat-icon>
          <span>Ausloggen</span>
        </button>
      </mat-menu>
    </mat-toolbar>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppHeaderComponent {

  readonly showMenuToggle = input(false);
  readonly menuToggleClick = output<void>();
  readonly logout = output<void>();
}
